import styled, { css } from 'styled-components';
import { up } from 'styled-breakpoints';

export const BottomBarContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e2e8f0;
  z-index: 40;
  padding-bottom: env(safe-area-inset-bottom, 0);

  ${up('lg')} {
    display: none;
  }
`;

export const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  padding: 0.5rem;
  gap: 0.25rem;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

type TabButtonProps = {
  $active?: boolean;
};

export const TabButton = styled.button<TabButtonProps>`
  ${({ $active }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.75rem;
    white-space: nowrap;
    position: relative;
    transition: all 0.2s ease;
    background: ${$active ? '#eef2ff' : 'transparent'};
    color: ${$active ? '#4f46e5' : '#64748b'};
    border: none;
    cursor: pointer;
    min-width: fit-content;

    &:hover {
      background: ${$active ? '#eef2ff' : '#f1f5f9'};
    }

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  `};
`;

export const TabLabel = styled.span`
  font-size: 0.625rem;
  font-weight: 500;
`;

export const Badge = styled.span`
  position: absolute;
  top: 0.125rem;
  right: 0.125rem;
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.25rem;
  background: #ef4444;
  color: white;
  font-size: 0.625rem;
  font-weight: 600;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
